export default {
  getBanquetInquiryDetails: state => {
    return state.banquetInquiryDetails;
  },
  getErrors: state => {
    return state.errors;
  },
  getApplicantInfo: state => {
    return state.applicantInfo;
  },
  getEventInfo: state => {
    return state.eventInfo;
  }
};
